module.exports = __webpack_public_path__ + "img/gsnd2760_1.e422ac35.svg";